import { render, staticRenderFns } from "./BeneficiariesPage.vue?vue&type=template&id=9505e59c&scoped=true&"
import script from "./BeneficiariesPage.vue?vue&type=script&lang=ts&"
export * from "./BeneficiariesPage.vue?vue&type=script&lang=ts&"
import style0 from "./BeneficiariesPage.vue?vue&type=style&index=0&id=9505e59c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9505e59c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VInput,VRow})
